(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('sidebarService', sidebarService);

  function sidebarService(
    mediaQueryService
  ) {
    'ngInject';

    const sidebarMinified = mediaQueryService.evaluateMediaQuery('mdMax') ? true : false;

    const expandMenuMapping = {
      callLogsExpanded: [
        'dashboard.new-call-logs'
      ],
      reportsExpanded: [
        'dashboard.call-logs',
        'dashboard.rtb-logs'
      ],
      insightsExpanded: [
        'dashboard.insights',
        'dashboard.event-insights',
        'dashboard.outbound-ping-http-failures'
      ],
      campaignsExpanded: [
        'dashboard.campaigns',
        'dashboard.campaign-wizard',
        'dashboard.viewcampaign'
      ],
      targetExpanded: [
        'dashboard.targets',
        'dashboard.target',
        'dashboard.targetgroups',
        'dashboard.targetgroup',
        'dashboard.buyers',
        'dashboard.buyer'
      ],
      pingtreeExpanded: [
        'dashboard.ringtreetargetdashboard',
        'dashboard.ringtreetargets',
        'dashboard.ringtreetarget',
        'dashboard.ringtrees',
        'dashboard.ringtree'
      ],
      ivrExpanded: [
        'dashboard.ivrs',
        'dashboard.ivr',
        'dashboard.call-plans'
      ],
      callFlowExpanded: [
        'dashboard.call-flows',
        'dashboard.call-flow',
      ],
      numberExpanded: [
        'dashboard.bulk-blocked-numbers',
        'dashboard.search-bulk-blocked-numbers',
        'dashboard.numberpools',
        'dashboard.numberpool',
        'dashboard.blocked-numbers',
        'dashboard.numbers',
      ],
      tcpaExpanded: [
        'dashboard.tcpa-shield'
      ],
      callbackExpanded: [
        'dashboard.callbacks',
        'dashboard.webhooks',
        'dashboard.adplatforms'
      ],
      settingsExpanded: [
        'dashboard.account-details',
        'dashboard.account-settings',
        'dashboard.predictive-routing',
        'dashboard.account-users',
        'dashboard.billing-settings',
        'dashboard.user-profile',
        'dashboard.whitelabel-settings',
        'dashboard.prp-settings',
        'dashboard.brp-settings'
      ],
      securityExpanded: [
        'dashboard.api-tokens',
        'dashboard.login-security',
        'dashboard.multi-factor-auth',
        'dashboard.rate-limits',
      ]
    };

    const service = {
      sidebarMinified: sidebarMinified,
      expandMenuMapping: expandMenuMapping
    };
    return service;
  }
})();
